/* eslint-disable */
export default {
  cancel: 'Annuler',
  confirm: 'Confirmer',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"confirm"@#@ @source: @#@"Confirm"@#@
